import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { BsPeople, BsPerson, BsCheck2Circle, BsDisplay, BsQuestion, BsFolder, BsGear } from 'react-icons/bs';
import Sidebar from '../../../src/components/dashboard/sidebar';
import Navbar from '../../../src/components/dashboard/navbar';
import useAuth from '../../../src/components/dashboard/useAuth';
import axios from 'axios';
import { FaCogs, FaUserShield, FaBoxes, FaChalkboardTeacher, FaQuestionCircle, FaTags, FaCogs as FaProcess, FaTh, FaRegQuestionCircle, FaStore, FaMoneyBillWave } from 'react-icons/fa';

const Boutique = ({ titre }) => {
  useAuth();
  const location = useLocation();
  const user_id = localStorage.getItem('IDDDD');
  const navigate = useNavigate();
  const accesGroupe = localStorage.getItem('accesGroupe');
  const groupe = localStorage.getItem('groupe');

  // Utilisation de useEffect pour mettre à jour le titre de la page
  useEffect(() => {
    if (user_id) {
      document.title = "eTrainApp | Ma boutique"; // Définit le titre de la page
    }
  }, [user_id]);


  const userHasAccess = (accessKey) => {
    // Vérifie si 'acces' est non nul et inclut 'accessKey'
    return accesGroupe && accesGroupe.includes(accessKey);
  };

  return (
    <div id="wrapper">
      <Sidebar user_id={user_id} titre={titre} />
      <div id="page-wrapper" className="gray-bg">
        <Navbar />
        <div>
          <div className="row wrapper border-bottom white-bg page-heading">
            <div className="col-lg-12">
              <h2 className='d-flex align-items-center'><FaStore size={25} className='mr-2' /> Ma boutique</h2>
              {/* <small>Ma boutique</small> */}

              <small id='hbreadcrumb' className='d-flex justify-content-end'>
                <ol className="hbreadcrumb breadcrumb">
                  <li className="breadcrumb-item custom-breadcrumb-item">
                    <Link to={`/boutique`}> Ma boutique</Link>
                  </li>
                </ol>
              </small>

            </div>
          </div>
          <div className="container text-center mt-5">
            <div className="row mx-auto justify-content-center">
              {/* Card for Produits */}

              <div className="col-md-2 mb-4">
                <div
                  className="card rounded shadow-sm"
                  style={{ cursor: 'pointer' }}
                  onClick={() => navigate('/mes-produits')}
                >
                  <div className="card-body">
                    <FaBoxes className="mb-3 icon-small" />
                    <h5 className="card-title">
                      <Link className='text-dark' to={`/mes-produits`}>Mes produits</Link>
                    </h5>
                  </div>
                </div>
              </div>

              {/* Card for ventes */}
              <div className="col-md-2 mb-4">
                <div 
                 className="card rounded shadow-sm" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => navigate('/suivi-vente')}
                >
                  <div className="card-body">
                    <img
                      src="/assets/images/vente.png"
                      alt="Suivi des ventes"
                      className="mb-3"
                      style={{ width: '24px', height: '24px' }}
                    />
                    <h5 className="card-title">
                      <Link className='text-dark' to={`/suivi-vente`}>Suivi des ventes</Link>
                    </h5>
                  </div>
                </div>
              </div>
              {/* Card for ventes */}
              <div className="col-md-2 mb-4">
                <div 
                 className="card rounded shadow-sm" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => navigate('/remboursements')}
                  >
                  <div className="card-body">
                    <img
                      src="/assets/images/rembourse.png"
                      alt="remboursements"
                      className="mb-2"
                      style={{ width: '31px', height: '31px' }}
                    />
                    <h5 className="card-title">
                      <Link className='text-dark' to={`/remboursements`}>Remboursements</Link>
                    </h5>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default Boutique;
